import { get } from 'lodash';
import { postRequest } from '../../services/requestService';
import {
  showErrorToast,
  showSuccessToast,
} from '../../services/notificationsService';

import * as authTypes from '../Auth/types';
import * as types from './types';

export const updateBuyerDetails = (
  params,
  successMessage = 'Updating buy box succeeded!',
  errorMessage = 'Updating buy box failed. Please try again!',
  callback,
) => async (dispatch) => {
  const hasChangedparams = Object.keys(params).length > 0;
  if (!hasChangedparams) return;

  dispatch({
    type: types.SET_LOADING,
    payload: { isLoading: true },
  });
  try {
    const res = await postRequest('/user/update-details', params);
    dispatch({
      type: authTypes.SET_USER_DATA,
      payload: {
        userDetails: res.data.userDetails,
        organization: res.data.userDetails.defaultOrganization,
      },
    });
    showSuccessToast(successMessage);
    if (callback) {
      callback();
    }
  } catch (error) {
    showErrorToast(errorMessage);
  }

  dispatch({
    type: types.SET_LOADING,
    payload: { isLoading: false },
  });
};

/**
 * Get buyer's buybox matched properties
 *
 * @param {*} userId A buyer Id
 */
export const getBuyBoxMatchedProperties = ({ userId, buyBoxList }) => async (
  dispatch,
  getState,
) => {
  if (!userId) return;

  dispatch({
    type: types.SET_BUYBOX_MATCHED_PROPERTIES,
    payload: {
      isFetchingBuyboxMatchedProperties: true,
      buyBoxMatchedProperties: [],
      buyBoxMatchedPropertyTotal: 0,
      isMatchingCountShown: true,
    },
  });
  const payload = { isFetchingBuyboxMatchedProperties: false };

  try {
    const res = await postRequest(`/backoffice/user/${userId}/buybox-matches`, {
      userId,
      buyBoxList,
    });
    const { reason, items, total, buyBoxPropertyMatch } = res.data;
    if (reason) {
      throw new Error(reason);
    }

    let matches = getState().BuyerReducer.buyBoxPropertyMatch || {};
    matches = { ...matches, ...(buyBoxPropertyMatch || {}) };

    payload.buyBoxMatchedPropertyTotal = total;
    payload.buyBoxMatchedProperties = items;
    payload.buyBoxPropertyMatch = matches;
  } catch (error) {
    const msg = get(error, 'response.data.reason');
    showErrorToast(msg || 'Oops, Please try again later');
  }

  dispatch({
    type: types.SET_BUYBOX_MATCHED_PROPERTIES,
    payload,
  });
};

/**
 * Updates buyBoxPropertyMatch in Buyer State
 *
 * @param {*} matches
 */
export const updateBuyBoxPropertyMatches = (matches) => async (dispatch) => {
  dispatch({
    type: types.SET_BUYBOX_MATCHED_PROPERTIES,
    payload: {
      buyBoxPropertyMatch: matches,
    },
  });
};

/**
 * Toggle isMatchingCountShown to hide/show matching counts in bybox list
 *
 * @param {*} matches
 */
export const setMatchingCountShown = (flag) => async (dispatch) => {
  dispatch({
    type: types.SET_MATCHING_COUNT_SHOWN,
    payload: {
      isMatchingCountShown: flag,
    },
  });
};
